import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import SideBar from '@/Components/Dashboard/Common/SideBar';
import DashboardHeader from '@/Components/Dashboard/Common/DashboardHeader';

export default function Dashboard({ children }) {
    const [isSideBarOpen, setIsSideBarOpen] = useState(false);
    const [isTicketView, setIsTicketView] = useState(false);
    const router = useRouter();

    useEffect(() => {
        setIsTicketView(router.pathname.includes("tickets"));
    }, [router.pathname]);

    return (
        <div className="min-h-screen max-w-[100vw] overflow-hidden no-selection flex flex-col">
            <div className="w-full max-w-[1440px] mx-auto flex min-h-screen">
                <div className="hidden lg:block">
                    <SideBar isTicketView={isTicketView} />
                </div>
                <div className="w-full">
                    <main className={`flex-grow max-w-[100vw] relative z-[1] ${isSideBarOpen ? "max-h-screen" : ""}`}>
                        <DashboardHeader isTicketView={isTicketView} isSideBarOpen={isSideBarOpen} setIsSideBarOpen={setIsSideBarOpen} />
                        <div className="py-1">{children}</div>
                    </main>
                </div>
            </div>
        </div>
    );
}
